<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<logo />
		<main-content>
			<div class="menu-items-wrapper">
				<div v-for="menu in menus" :key="menu.ID" class="menu-item columns column4">
					<picture>
						<source :srcset="menu.image" />
						<img :src="menu.image" :alt="menu.imageAlt" loading="lazy" />
					</picture>
					<div v-parse-links v-html="menu.menuFile" />
				</div>
			</div>
			<div v-if="page.content" class="row">
				<div class="columns column12">
					<div class="sub-content-wrapper">
						<div v-parse-links v-html="page.content" />
					</div>
				</div>
			</div>
		</main-content>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();

const { data: menus } = await useWebsiteFetch('menus', {
	query: { language: locale.value },
	key: `${locale.value}/menus`,
});
</script>

<style lang="scss" scoped>
.menu-items-wrapper {
	display: flex;
	flex-flow: row wrap;
	width: 100%;
	height: 100%;
	justify-content: center;
	align-items: center;
	text-align: center;
	position: relative;
	padding: 0;

	> div {
		z-index: 3;
		position: relative;
		margin: 10px 0;
		padding: 0 40px;
		width: 31%;
		text-align: center;
	}

	:deep(a) {
		border: none;
		text-decoration: none;
		text-transform: uppercase;
	}

	:deep(p) {
		margin: 15px 0;
	}
}

.sub-content-wrapper {
	padding: 100px 0 25px;
}

@media (max-width: 1080px) {
	.menu-items-wrapper {
		> div {
			padding: 0 20px;
		}
	}
}

@media (max-width: 800px) {
	.menu-items-wrapper {
		> div {
			padding: 0 10px;
		}
	}
}
</style>
